import * as actionTypes from "./DemandOpportunityType";

const INITIAL_STATE = {
  oppList: [],
  oppTaskList: [],
  oppStageHistory: [],
  opp: null,
  oppStagesList: [],
  oppTypeList: [],
  oppServiceCategoryList: [],
  oppStatusList: [],
  oppComments: [],
  oppQuoteInvoice: [],
  oppDeliverablesList: [],
  oppDeliverables: null,
  oppDeliverablesByType: [],
  stagewiseCount: [],
  statuswiseCount: [],
  taskList: [],
  taskDeliverables: [],
  commentsById: [],
  opportunityByOppId: null,
  opportunityOrderList: [],
  invoiceRequestList: [],
  deliveryPendingList: [],
  opportunitySummary: {
    totalOpportunity: 0,
    ongoingOpportunity: 0,
    hold: 0,
    completedThisMonth: 0,
    newOpportunityThisMonth: 0,
    totalOpportunityValues: 0,
    totalOpportunityValueCurrentMonth: 0,
    totalInvoiceValueCurrentMonth: 0
  },
};

const DemandOpportunityReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_OPP_LIST:
      return { ...state, oppList: action.payload.list };
    case actionTypes.SET_OPP_TASK_LIST:
      return { ...state, oppTaskList: action.payload.list };
    case actionTypes.SET_OPP_STAGE_HISTORY:
      return { ...state, oppStageHistory: action.payload.list };
    case actionTypes.SET_OPP:
      return { ...state, opp: action.payload.data };
    case actionTypes.SET_OPP_STAGES_LIST:
      return { ...state, oppStagesList: action.payload.list };
    case actionTypes.SET_OPP_TYPE_LIST:
      return { ...state, oppTypeList: action.payload.list };
    case actionTypes.SET_OPP_SERVICE_CATEGORY_LIST:
      return { ...state, oppServiceCategoryList: action.payload.list };
    case actionTypes.SET_OPP_STATUS_LIST:
      return { ...state, oppStatusList: action.payload.list };
    case actionTypes.SET_OPP_COMMENTS:
      return { ...state, oppComments: action.payload.list };
    case actionTypes.SET_OPP_QUOTE_INVOICE:
      return { ...state, oppQuoteInvoice: action.payload.list };
    case actionTypes.SET_OPP_DELIVERABLES_LIST:
      return { ...state, oppDeliverablesList: action.payload.list };
    case actionTypes.SET_OPP_DELIVERABLES:
      return { ...state, oppDeliverables: action.payload.data };
    case actionTypes.SET_OPP_STAGEWISE_COUNT:
      return { ...state, stagewiseCount: action.payload.list };
    case actionTypes.SET_OPP_STATUSWISE_COUNT:
      return { ...state, statuswiseCount: action.payload.list };
    case actionTypes.SET_OPP_TASK_LIST_FULL:
      return { ...state, taskList: action.payload.list };
    case actionTypes.SET_OPP_TASK_DELIVERABLES:
      return { ...state, taskDeliverables: action.payload.list };
    case actionTypes.SET_OPP_COMMENTS_BY_ID:
      return { ...state, commentsById: action.payload.list };
    case actionTypes.SET_OPPORTUNITY_BY_OPPID:
      return { ...state, opportunityByOppId: action.payload.data };
    case actionTypes.SET_OPP_ORDER_LIST:
      return { ...state, opportunityOrderList: action.payload.list };
    case actionTypes.SET_OPP_INVOICE_REQUEST_LIST:
      return { ...state, invoiceRequestList: action.payload.list };
    case actionTypes.SET_OPP_DELIVERY_PENDING_LIST:
      return { ...state, deliveryPendingList: action.payload.list };
    case actionTypes.SET_OPP_DELIVERABLES_BY_TYPE:
      return { ...state, oppDeliverablesByType: action.payload.list };
    case actionTypes.SET_OPPORTUNITY_SUMMARY:
      return { ...state, opportunitySummary: action.payload };
    case actionTypes.CLEAR_OPP:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default DemandOpportunityReducer;
